// extracted by mini-css-extract-plugin
export var locationCard = "_fw-0";